module.exports = __webpack_public_path__ + "static/media/sailing.edd5b6c8.jpg";